import { render, staticRenderFns } from "./ParagraphExecute.vue?vue&type=template&id=1c054f60"
import script from "./ParagraphExecute.vue?vue&type=script&lang=js"
export * from "./ParagraphExecute.vue?vue&type=script&lang=js"
import style0 from "./ParagraphExecute.vue?vue&type=style&index=0&id=1c054f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports